<template>
  <gat-select
    v-if="showAll"
    :label="labelComputed"
    v-model="model"
    :items="items"
    textFieldName="NAME"
    codeFieldName="ID"
    :autofocus="autofocus"
    :readonly="readonly"
    :required="required"
    :clearable="clearable"
    @input="updateValue()"
    :disabled="disabled"
    :useIcons="useIcons">
  </gat-select>
  <gat-lookup-edit
    v-else
    :label="labelComputed"
    v-model="model"
    :searchresult="items"
    @getItems="getItems($event)"
    textFieldName="displayName"
    codeFieldName="ID"
    :cashSearches="true"
    :size="size"
    :autofocus="autofocus"
    :readonly="readonly"
    :required="required"
    :rules="clientRules"
    :disabled="disabled"
    :clearable="clearable"
    @input="updateValue()"
    @itemNotFound="itemNotFound"
    customItem>
    <template v-slot:item="{ data }">
      <div>{{ data['displayName'] }}</div>
      <div v-if="showClientWarning || showClientCreditLimit" class="ml-auto">
        <v-icon
          v-if="showClientWarning && +data.SHOW_WARNING === 1"
          class="orange--text"
          :class="showClientCreditLimit && data.CLIENT_CREDIT_FLAG > 0 ? 'mr-1' : ''"
          >mdi-alert</v-icon
        >
        <v-icon
          v-if="showClientCreditLimit && data.CLIENT_CREDIT_FLAG > 0"
          :class="getClienCreditFlagColor(+data.CLIENT_CREDIT_FLAG)"
          >mdi-flag</v-icon
        >
      </div>
    </template>
  </gat-lookup-edit>
</template>

<script>
import { apiGet, apiPost } from '@/store/api';

export default {
  name: 'GatClientSelect',
  props: {
    value: Number,
    callId: {
      type: [String, Number],
      required: false,
    },
    size: String,
    category: String,
    label: String,
    role: {
      type: [String, Number],
    },
    showAll: Boolean,
    autofocus: Boolean,
    readonly: Boolean,
    required: Boolean,
    disabled: Boolean,
    clearable: {
      type: Boolean,
      default: true,
    },
    useIcons: Boolean,
    showClientCreditLimit: Boolean,
    showClientWarning: Boolean,
    requireAccountNo: Boolean,
  },
  setup() {
    return {};
  },
  components: {},
  data() {
    return {
      items: [],
      model: null,
      item: {},
    };
  },

  computed: {
    clientRules() {
      const accountNo = String(this.item.ACCOUNT_NO ?? '').trim();
      return this.requireAccountNo
        ? [!this.model || (this.item.ID == this.model && !!accountNo) || 'Client number required']
        : [];
    },

    labelComputed() {
      let result = this.label;
      if (!result) {
        result = 'Client';
      }
      return result;
    },
  },

  created() {},

  watch: {
    value: {
      handler(val) {
        this.model = val;
        this.setItem(val, this.items);
      },
      immediate: true,
    },

    items(val) {
      this.setItem(this.model, val);
    },

    showAll(all) {
      if (all) {
        this.getItems('');
      }
    },
  },

  methods: {
    getItems(searchText) {
      apiPost('helper/search/', {
        table: 'client',
        text: searchText,
        text2: this.role,
        callId: this.callId,
      }).then((data) => {
        let clients = data;
        if (typeof this.category !== 'undefined') {
          clients = clients.filter((item) => item.CATEGORY == this.category);
        }
        clients = this.filterClients(clients);
        this.setDisplayName(clients);
        this.items = clients;
      });
    },

    filterClients(clients) {
      return this.requireAccountNo ? clients.filter((client) => String(client.ACCOUNT_NO ?? '').trim()) : clients;
    },

    setDisplayName(clients) {
      // eslint-disable-next-line array-callback-return
      clients.map((client) => {
        let displayName = client.NAME;
        if (client.ACCOUNT_NO) {
          displayName = `${displayName} (${client.ACCOUNT_NO})`;
        }
        // eslint-disable-next-line no-param-reassign
        client.displayName = displayName;
      });
    },

    setItem(id, items) {
      if (id && items && items.length > 0) {
        const item = items.find((x) => x.ID == id);
        if (item && item.ID != this.item.ID) {
          this.item = item;
          this.$emit('item-selected', item);
        }
      }
    },

    updateValue() {
      this.$emit('input', this.model);
      this.setItem(this.model, this.items);
    },

    itemNotFound(id) {
      if (this.requireAccountNo && this.model == id) {
        this.item = {};
      }
      return apiGet(`helper/client/id/${id}`)
        .then((data) => {
          if (this.model != id) return;
          const clients = this.filterClients(data);
          if (this.requireAccountNo && !clients.some((client) => client.ID == id)) {
            this.model = null;
            this.item = {};
            this.updateValue();
            return;
          }
          this.setDisplayName(clients);
          this.items = clients;
        })
        .catch(() => {
          if (this.model != id || !this.requireAccountNo) return;
          this.model = null;
          this.item = {};
          this.updateValue();
        });
    },

    getClienCreditFlagColor(value) {
      let result = '';
      switch (+value) {
        case 0:
          result = 'd-none';
          break;
        case 1:
          result = 'red--text text--darken-1';
          break;
        case 2:
          result = 'orange--text text--darken-1';
          break;
        case 3:
          result = 'green--text text--darken-1';
          break;
        default:
          result = 'd-none';
          break;
      }
      return result;
    },
  },
};
</script>

<style scoped></style>
